// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__2gGrJ","overflowing":"ReadFullNote_overflowing__185aG"};